import { defineComponent as t, openBlock as n, createBlock as a, unref as p, mergeProps as l, withCtx as m, createElementVNode as c } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const d = /* @__PURE__ */ t({
  name: "IconArrowUp",
  __name: "IconArrowUp",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const r = o;
    return (i, e) => (n(), a(p(s), l(r, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        c("path", { d: "M16.47 8.427a.75.75 0 1 0 1.06-1.06L12.884 2.72a1.25 1.25 0 0 0-1.768 0L6.47 7.366a.75.75 0 0 0 1.06 1.06l3.72-3.719v16.19a.75.75 0 1 0 1.5 0V4.706l3.72 3.72" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  d as default
};
